import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ListOfAssetsWidget from '../../../widgets/durableArticlesWidget/listOfAssets/ListOfAssetsWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { getListOfAssets } from '../../../redux/actions/listOfAssets'
import { getAssetRevolvingSchema } from '../../../redux/actions/accountingAssetClosure'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import AssetRevolvingWidget from '../../../widgets/durableArticlesWidget/assetRevolving/AssetRevolvingWidget'

export default function ManageAssetRevolving({ step }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  // const [isSupplyOfficer, setIsSupplyOfficer] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAssetRevolvingSchema()
      //const response = mock
      if (response.model) {
        setSchema(response.model)
      } else {
        setError({})
      }
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />
        <AssetRevolvingWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
